// Iconos SVG inline — line-style 24×24, color via currentColor
function PhoneIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}
function PersonIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}
function RobotIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="4" y="7" width="16" height="13" rx="2" />
      <path d="M12 7V3" />
      <circle cx="12" cy="3" r="1" />
      <circle cx="9" cy="13" r="1" fill="currentColor" />
      <circle cx="15" cy="13" r="1" fill="currentColor" />
      <path d="M9 17h6" />
      <path d="M2 13h2M20 13h2" />
    </svg>
  );
}
function BoltIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
    </svg>
  );
}

const SERVICES = [
  {
    icon: PhoneIcon,
    duration: "30 min",
    title: "Discovery Call",
    desc: "Primera conversación para entender tu negocio e identificar dónde la IA puede generar impacto inmediato.",
    result: "Claridad total sobre tu siguiente paso con IA.",
    audience: "Negocios que quieren explorar IA sin compromisos.",
    cta: "Discovery Call →",
  },
  {
    icon: PersonIcon,
    duration: "60 min",
    title: "Consultoría 1:1",
    desc: "Sesión estratégica personalizada para planificar e implementar IA según tus objetivos e industria.",
    result: "Plan de acción concreto con herramientas funcionando ese día.",
    audience: "Solopreneurs, consultores y líderes de equipo.",
    cta: "Agenda Sesión →",
  },
  {
    icon: RobotIcon,
    duration: "60 min",
    title: "Agentes IA Personalizados",
    desc: "Diseño e implementación de agentes que automatizan conversaciones, agendamiento y atención al cliente.",
    result: "Ahorro del 70% en tiempo de soporte. Disponible 24/7.",
    audience: "Clínicas, despachos legales y PyMEs en LATAM.",
    cta: "Solicitar Agente →",
  },
  {
    icon: BoltIcon,
    duration: "60 min",
    title: "Diagnóstico de IA",
    desc: "Auditoría integral de tus procesos para identificar quick wins donde la IA genera impacto inmediato.",
    result: "Reporte de oportunidades de automatización y ahorro.",
    audience: "Empresas que ya usan IA pero quieren optimizarla.",
    cta: "Solicita Diagnóstico →",
  },
];

export default function Services() {
  return (
    <section
      id="servicios"
      className="reveal"
      style={{
        position: "relative",
        zIndex: 2,
        background: "var(--surface-light)",
        padding: "100px 28px",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            gap: 24,
            marginBottom: 48,
            flexWrap: "wrap",
          }}
        >
          <div>
            <div className="eyebrow" style={{ marginBottom: 14 }}>
              Servicios
            </div>
            <h2
              className="font-display"
              style={{
                fontSize: "clamp(2rem, 4.6vw, 3.4rem)",
                fontWeight: 500,
                letterSpacing: "-0.02em",
                lineHeight: 1.05,
                margin: 0,
                maxWidth: 640,
              }}
            >
              Cómo trabajamos{" "}
              <em style={{ fontStyle: "italic", fontWeight: 400 }}>juntos.</em>
            </h2>
          </div>
          <p
            style={{
              fontSize: 15,
              lineHeight: 1.6,
              color: "var(--ink-dim)",
              maxWidth: 360,
              margin: 0,
            }}
          >
            Cuatro formatos para llevarte de cero a un sistema IA funcionando
            en tu negocio.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 16,
          }}
        >
          {SERVICES.map((s) => (
            <ServiceCard key={s.title} service={s} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service }) {
  const Icon = service.icon;
  return (
    <article
      style={{
        position: "relative",
        background: "rgba(255,255,255,0.55)",
        border: "1px solid var(--line)",
        borderRadius: 18,
        padding: "28px 26px",
        display: "flex",
        flexDirection: "column",
        gap: 14,
        minHeight: 380,
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 38,
            height: 38,
            borderRadius: 10,
            background: "rgba(17,17,16,0.06)",
            color: "var(--ink)",
          }}
        >
          <Icon />
        </span>
        <span
          style={{
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: "var(--ink-dim)",
          }}
        >
          {service.duration}
        </span>
      </header>

      <h3
        className="font-display"
        style={{
          fontSize: "1.4rem",
          fontWeight: 500,
          letterSpacing: "-0.015em",
          lineHeight: 1.15,
          margin: 0,
        }}
      >
        {service.title}
      </h3>

      <p
        style={{
          fontSize: 14,
          lineHeight: 1.6,
          color: "var(--ink-dim)",
          margin: 0,
        }}
      >
        {service.desc}
      </p>

      <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 12.5 }}>
        <li
          style={{
            display: "flex",
            gap: 8,
            paddingTop: 10,
            borderTop: "1px solid var(--line)",
          }}
        >
          <span style={labelStyle}>Resultado</span>
          <span style={valueStyle}>{service.result}</span>
        </li>
        <li
          style={{
            display: "flex",
            gap: 8,
            paddingTop: 10,
            marginTop: 10,
            borderTop: "1px solid var(--line)",
          }}
        >
          <span style={labelStyle}>Para quién</span>
          <span style={valueStyle}>{service.audience}</span>
        </li>
      </ul>

      <div style={{ marginTop: "auto", paddingTop: 14 }}>
        <a
          href="#contacto"
          onClick={(e) => {
            e.preventDefault();
            document
              .getElementById("contacto")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          className="btn-primary"
          style={{ width: "100%", justifyContent: "center" }}
        >
          {service.cta}
        </a>
      </div>
    </article>
  );
}

const labelStyle = {
  flex: "0 0 78px",
  fontSize: 10,
  fontWeight: 500,
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: "var(--ink-mute)",
  paddingTop: 1,
};

const valueStyle = {
  flex: 1,
  color: "var(--ink)",
  lineHeight: 1.5,
};
